<template>
  <div>
    <ContentHeader :showBack="false" />

    <div class="content-container">
      <div class="search-top-row">
        <el-row>
          <el-col style="text-align:center">
            <el-select
              v-if="employeeLevel === 50"
              v-model="queryParams.orgCode"
              size="small"
              placeholder="选择区域"
              clearable
              filterable
            >
              <el-option
                v-for="(item, idx) in orgList"
                :key="idx"
                :value="item.orgCode"
                :label="item.orgName"
              />
            </el-select>
            <el-select
              v-model="queryParams.channelCode"
              size="small"
              placeholder="选择渠道"
              clearable
              filterable
            >
              <el-option
                v-for="(item, idx) in channelList"
                :key="idx"
                :value="item.key"
                :label="item.value"
              />
            </el-select>
            <el-input
              class="search-input"
              v-model="queryParams.themeName"
              placeholder="主题名称"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search noselect"
              ></i>
            </el-input>
            <el-button class="btn-red" size="small" @click="getThemeList()"
              >搜索</el-button
            >
            <el-button class="btn-reset" size="small" @click="resetSearch()"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>

      <div class="theme-bottom" v-loading="loading">
        <!-- 列表详情 -->
        <div
          class="theme-list-item"
          v-for="(item, index) in themeList"
          :key="index"
        >
          <PerfectHistoryListItem :info="item"></PerfectHistoryListItem>
        </div>
        <div class="no-data" v-if="themeList.length === 0">暂无数据</div>

        <!-- 翻页 -->
        <el-row v-if="themeList.length != 0" class="footer-pagination">
          <el-col>
            <el-pagination
              background
              :current-page="page"
              :page-size="pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import ContentHeader from '../../components/content-header'
import PerfectHistoryListItem from './components/perfect-history-list-item'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  name: 'perfect-history-list',
  components: {
    ContentHeader,
    PerfectHistoryListItem
  },
  data () {
    return {
      loading: false,
      themeList: [],
      orgList: [], // 区域
      page: 1,
      pageSize: 10,
      total: null,
      employeeLevel: '',
      queryParams: {
        channelCode: '',
        orgCode: '',
        themeName: ''
      }
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      channelList: state => state.base.tradeStackThemeChannelMap
    })
  },

  mounted () {
    this.getOrgList()
  },

  created () {
    this.$store.dispatch('getDictByName', 'tradeStackThemeChannelMap')
    this.employeeLevel = this.userInfo.employeeLevel
    if (localStorageUtils.get('stackPerfectQueryParams')) {
      this.queryParams = JSON.parse(
        localStorageUtils.get('stackPerfectQueryParams')
      )
      this.queryParams.page = 1
    }
    this.getThemeList()
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'perfect-theme-config') {
      localStorageUtils.set(
        'stackPerfectQueryParams',
        JSON.stringify(this.queryParams)
      )
    } else {
      localStorageUtils.remove('stackPerfectQueryParams')
    }
    next()
  },

  methods: {
    // 获取列表
    getThemeList () {
      this.loading = true
      let params = _.assign(this.queryParams, {
        page: this.page,
        pageSize: 10,
        isActive: 0
      })
      this.$store
        .dispatch('themeList', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.themeList =
              res.data.resultData.tradeStackThemeDefineList || []
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 重置
    resetSearch () {
      this.queryParams = this.$options.data().queryParams
      this.getThemeList()
    },
    // 获取区域
    getOrgList () {
      this.$store
        .dispatch('areaList')
        .then(res => {
          if (res.data.resultCode === '0') {
            if (this.employeeLevel === 50) {
              this.orgList = res.data.resultData.regionList || []
            }
            if (this.employeeLevel === 60) {
              this.orgList = res.data.resultData.buList || []
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.getThemeList()
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-reset {
  background-color: #7f7f7f;
  color: #ffffff;
}
.menu-row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 870px;
  height: 240px;
  margin: 20px auto 40px;
  color: #666a73;
  .menu-card-carousel {
    display: flex;
    justify-content: center;
    width: 780px;
  }
  .card-carousel--overflow-container {
    overflow: hidden;
  }

  .card-carousel-cards {
    display: flex;
    transition: transform 0.25s ease-out;
    transform: translatex(0px);
    height: 180px;
    text-align: center;
    box-sizing: border-box;
  }
  .card-carousel-cards-item {
    position: relative;
    margin: 0 20px;
    background-color: #fff;
    border-radius: 4px;
    z-index: 3;
    margin-bottom: 2px;
    flex-shrink: 0;
    width: 220px;
    border-radius: 15px;
    .card-theme,
    .card-status {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
    }
    .status-num {
      color: $base-red;
    }
    .theme {
      margin: 15px 15px;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
    }
    .status {
      margin: 15px 35px;
    }
    .time-range {
      font-size: 12px;
      margin: 15px;
    }
    .create-btn {
      position: absolute;
      width: 100%;
      height: 34px;
      bottom: 0;
      background-color: $base-red;
      border-bottom-right-radius: 15px;
      border-bottom-left-radius: 15px;
      cursor: pointer;
    }
    .create-img {
      width: 24px;
      height: 24px;
      margin: 5px auto 5px;
      background: url("../../assets/images/create.png") no-repeat;
    }
    .hasCreate {
      background-color: #c0c0c0;
    }
    .theme-name {
      width: 50%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .theme-channel {
      width: 50%;
    }
  }
  .menu-row-left,
  .menu-row-right {
    display: inline-block;
    width: 20px;
    height: 20px;
    padding: 8px;
    box-sizing: border-box;
    border-top: 4px solid $base-red;
    border-right: 4px solid $base-red;
    cursor: pointer;
    margin: 0 10px;
    transition: transform 0.2s linear;
  }
  .menu-row-left[disabled],
  .menu-row-right[disabled] {
    opacity: 0.2;
    border-color: black;
    cursor: not-allowed;
  }
  .menu-row-left {
    transform: rotate(-135deg);
  }
  .menu-row-left:active {
    transform: rotate(-135deg) scale(0.85);
  }
  .menu-row-right {
    transform: rotate(45deg);
  }
  .menu-row-right:active {
    transform: rotate(45deg) scale(0.85);
  }
}
.theme-bottom {
  width: 870px;
  margin: 0 auto;
}
.theme-list-item {
  height: 100px;
  margin: 0 auto 20px;
  padding: 0 10px;
  box-sizing: border-box;
}
.no-data {
  text-align: center;
}

.search-input.el-input {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.search-input {
  .el-input__icon {
    line-height: 32px;
  }
  ::v-deep .el-input__inner {
    height: 32px;
    border-radius: 5px;
  }
}

.el-select {
  width: 131px;
  height: 36px;
  margin: 0 15px 10px 0;
}
.footer-pagination {
  width: 720px;
  text-align: center;
  margin: 40px 0px 0px;
  height: 48px;
}
</style>
